import BudgetModulePageShell from "../components/BudgetModulePageShell";
import { AppLoader } from "../components/Loaders";
import { useBudgetModuleYears } from "../hooks/useBudgetModuleYears";
import { useAuth } from "../state/AuthContext";

const BudgetDashboardPage = () => {
  const { token } = useAuth();
  const { yearCards, selectedYear, setSelectedYear, loading, error } =
    useBudgetModuleYears(token);

  return (
    <BudgetModulePageShell
      title="Budget Module Dashboard"
      description=""
      yearCards={yearCards}
      selectedYear={selectedYear}
      onSelectYear={setSelectedYear}
    >
      {error ? <div className="alert alert--error">{error}</div> : null}

      {loading ? (
        <AppLoader label="Loading dashboard..." />
      ) : yearCards.length === 0 ? (
        <div className="base-container" />
      ) : (
        <div className="base-container budget-dashboard-summary">
          <div className="budget-dashboard-tile">
            <span>Selected year</span>
            <strong>{selectedYear || "-"}</strong>
          </div>
          <div className="budget-dashboard-tile">
            <span>Budget workspaces</span>
            <strong>{yearCards.filter((item) => item.has_workspace).length}</strong>
          </div>
          <div className="budget-dashboard-tile">
            <span>Import drafts</span>
            <strong>{yearCards.filter((item) => item.has_import_draft).length}</strong>
          </div>
        </div>
      )}
    </BudgetModulePageShell>
  );
};

export default BudgetDashboardPage;
